import { useState, useEffect } from 'react';

import { FormControl, FormHelperText, InputAdornment } from "@mui/material";
import { MapitInput, MapitInputLabel } from './basic-components';
import { useTranslation } from 'react-i18next';
import { VisibilityOutlined, VisibilityOffOutlined } from '@mui/icons-material';

const MapitFormInput = ({
    error,
    optional = false,
    password = false,
    ...props
}) => {

    const { t } = useTranslation("public");

    const [type, setType] = useState(props?.type ?? "text");

    const changeType = () => {
        if (type === "password") {
            setType("text");
        } else {
            setType("password");
        }
    }

    useEffect(() => {
        setType(props?.type ?? "text");
    }, [props?.type])

    return (
        <FormControl error={Boolean(error)} fullWidth variant="standard">
            <MapitInputLabel shrink htmlFor={props?.name}>
                {props?.label}
                {optional &&
                    <span
                        style={{
                            marginRight: "7px",
                            marginLeft: "7px",
                            color: "#98A2B3",
                            fontSize: "14px",
                            fontWeight: "400",
                            lineHeight: "20px",
                        }}>
                        {`(${t("form.optional")})`}
                    </span>
                }
                {props?.required && <span>{" *"}</span>}
            </MapitInputLabel>
            <MapitInput
                id={props?.name}
                helperText={error}
                InputLabelProps={{
                    required: false,
                    sx: {
                        color: "text.placeholder",
                    },
                    shrink: Boolean(props.value)
                }}
                endAdornment={
                    password && (
                        <InputAdornment position="end">
                            {type === "password" ?
                                <VisibilityOffOutlined fontSize='small' onClick={changeType} sx={{ cursor: "pointer", fontSize: 20 }} />
                                :
                                <VisibilityOutlined fontSize='small' onClick={changeType} sx={{ cursor: "pointer", fontSize: 20 }} />
                            }
                        </InputAdornment>
                    )
                }
                {...props}
                type={type}
            />
            {error ? <FormHelperText error={true}>{error}</FormHelperText> : null}
        </FormControl >
    );
}

export default MapitFormInput;
